"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState, useEffect } from "react";
const projects = [{
  id: 1,
  title: "  COMMERCIAL MIXED USE ",
  image: "https://dealforgere.com/wp-content/uploads/2026/02/Tamiro-2.jpg?v=rky0nmupik",
  value: "$7.5M",
  type: "Commercial",
  year: "2018"
}, {
  id: 2,
  title: "LUXURY RESIDENTIAL",
  image: "https://dealforgere.com/wp-content/uploads/2026/02/Screenshot-2026-02-11-at-11.31.43-AM.png?v=3ihpy62ody6",
  value: "$4M",
  type: "Residential",
  year: "2021"
}, {
  id: 3,
  title: "OFF MARKET COMMERCIAL ACQUISITION",
  image: "https://dealforgere.com/wp-content/uploads/2026/02/Screenshot-2026-02-11-at-11.42.15-AM.png?v=2vi4alpelbh",
  value: "$48M",
  type: "Commercial",
  year: "2021"
}, {
  id: 4,
  title: "LUXURY RESIDENTIAL DEVELOPMENT",
  image: "https://dealforgere.com/wp-content/uploads/2026/02/Screenshot-2026-02-11-at-11.48.42-AM.png?v=fkmnw35jk8h",
  value: "$2.7M",
  type: "Development",
  year: "2023"
}, {
  id: 5,
  title: "Investment Portfolio Advisory",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/investment_portfolio_architecture.png",
  value: "$75M",
  type: "Portfolio",
  year: "2020"
}];
export default function Experience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  const progress = count > 0 ? current / count * 100 : 0;
  return <section id="experience" ref={ref} className={`py-20 bg-background transition-opacity duration-300 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-primary mb-4">Experience</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Over 20 years of strategic real estate advisory and $2B+ in
            successfully completed transactions across residential, commercial,
            and land development projects.
          </p>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-6">
            {projects.map((project, i) => <CarouselItem key={project.id} data-index={i} className="pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="group overflow-hidden h-full">
                  <div className="relative overflow-hidden aspect-[4/3]">
                    <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                    <div className="surface-overlay absolute inset-0" />
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white text-xl font-semibold">
                        {project.title}
                      </h3>
                    </div>
                  </div>
                  <CardContent className="pt-6">
                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <p className="text-muted-foreground text-xs uppercase tracking-wider mb-1">
                          Value
                        </p>
                        <p className="text-secondary font-semibold">
                          {project.value}
                        </p>
                      </div>
                      <div>
                        <p className="text-muted-foreground text-xs uppercase tracking-wider mb-1">
                          Type
                        </p>
                        <p className="text-secondary font-semibold">
                          {project.type}
                        </p>
                      </div>
                      <div>
                        <p className="text-muted-foreground text-xs uppercase tracking-wider mb-1">
                          Year
                        </p>
                        <p className="text-secondary font-semibold">
                          {project.year}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>

          <div className="hidden md:block">
            <CarouselPrevious className="-left-14" />
            <CarouselNext className="-right-14" />
          </div>
        </Carousel>

        <div className="mt-8 max-w-3xl mx-auto">
          <Progress value={progress} className="h-1" />
          <div className="flex justify-between items-center mt-3">
            <p className="text-muted-foreground text-sm">
              Project {current} of {count}
            </p>
            <p className="text-muted-foreground text-sm">
              Swipe or use arrows to navigate
            </p>
          </div>
        </div>
      </div>
    </section>;
}